import PropTypes from "prop-types";
import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import {
  showSpinner,
  hideSpinner
} from "../../redux/actions/learningCenter/contentPlayerActions";

const GoogleDocsViewer = ({
  height,
  width,
  url,
  embedded,
  showSpinner,
  hideSpinner
}) => {
  const iframeRef = useRef(null);
  const iframeIsLoaded = useRef(false);
  const reloadUrlInterval = useRef(null);

  const getUrl = () => {
    let src = `https://docs.google.com/viewer?url=${url}`;
    if (embedded) {
      src += "&embedded=true";
    }
    return src;
  };

  const handleIframeLoad = () => {
    iframeIsLoaded.current = true;
    clearInterval(reloadUrlInterval.current);
    hideSpinner();
  };

  const updateIframeSrc = () => {
    if (iframeRef && iframeRef.current && !iframeIsLoaded.current) {
      iframeRef.current.src = getUrl();
    }
  };

  useEffect(() => {
    if (!iframeIsLoaded.current) {
      showSpinner();
      reloadUrlInterval.current = setInterval(updateIframeSrc, 3000);
    }
  }, [url]);

  return (
    <div>
      <iframe
        onLoad={handleIframeLoad}
        onError={updateIframeSrc}
        allowFullScreen
        ref={iframeRef}
        src={getUrl()}
        frameBorder="0"
        title="iframe"
        height={height}
        width={width}
      />
    </div>
  );
};

GoogleDocsViewer.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  url: PropTypes.string,
  embedded: PropTypes.bool
};

GoogleDocsViewer.defaultProps = {
  height: "300px",
  width: "100%",
  url: "",
  embedded: true
};

export default connect(null, { showSpinner, hideSpinner })(GoogleDocsViewer);
